import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { socket } from '../socket'

// Display pages that report themselves to the dashboard's Pages overview
export const TRACKED_PAGES = {
	'/': 'Post Game',
	'/2v2': 'Post Game 2v2',
	'/livegame': 'Live Game',
	'/livegameoverlay': 'Live Game Overlay',
	'/draftdisplay': 'Draft Display',
	'/altdraftdisplay': 'Alt Draft Display',
	'/bracketdisplay': 'Bracket Display',
	'/roundrobindisplay': 'Round Robin Display',
	'/civilizationcards': 'Civilization Cards',
}

export function normalizePagePath(pathname) {
	const path = pathname.replace(/\/+$/, '').toLowerCase()
	return path === '' ? '/' : path
}

// One id per page load; a reload (or closing the tab) creates a new instance
const instanceId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
const openedAt = Date.now()

// Never send auth credentials along to the overview
function publicSearch(search) {
	const params = new URLSearchParams(search)
	params.delete('token')
	params.delete('key')
	const result = params.toString()
	return result ? `?${result}` : ''
}

export function PageInstanceTracker() {
	const location = useLocation()
	// Dashboard previews (?preview) mount and unmount while switching tabs, so they aren't tracked
	const isPreview = new URLSearchParams(location.search).has('preview')
	const tracked = !isPreview && normalizePagePath(location.pathname) in TRACKED_PAGES

	useEffect(() => {
		if (!tracked) return

		function onReloadPage() {
			window.location.reload()
		}

		function onUnload() {
			socket.emit('closePageInstance', instanceId)
		}

		socket.on('reloadPage', onReloadPage)
		window.addEventListener('beforeunload', onUnload)

		return () => {
			socket.off('reloadPage', onReloadPage)
			window.removeEventListener('beforeunload', onUnload)
			onUnload()
		}
	}, [tracked])

	useEffect(() => {
		if (!tracked) return

		function announce() {
			socket.emit('announcePageInstance', {
				instanceId,
				openedAt,
				page: location.pathname,
				search: publicSearch(location.search),
			})
		}

		if (socket.connected) announce()
		socket.on('connect', announce)

		return () => {
			socket.off('connect', announce)
		}
	}, [tracked, location.pathname, location.search])

	return null
}
